export default{
  "Video Compressor": "Comprimir video",
  "HitPaw Online Video Compressor": "HitPaw comprimir video online",
  "Best video compressor tool to reduce video file size online without losing quality.": "La mejor herramienta para comprimir video,  reducir el tamaño de video online sin perder calidad.",
  "Quality": "Calidad",
  "Small Size": "Tamaño pequeño ({{num}}%)",
  "High Quality": "Calidad alta ({{num}}%)",
  "Frame Rate": "Fotogramas por segundo",
  "Resolution": "Resolución",
  "Keep Resolution": "Mantener resolución",
  "Format": "Formato",
  "Compress": "Comprimir",
  "Compressing": "Comprimiendo",
  "Compress New": "Comprimir nuevo",
  "xx% reduction in size!": "{{num}}% tamaño se ha reducido",
  "Compressed successfully, your file is now xxMB.": "Comprimido correctamente, tu archivo ahora tiene <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "compresión falló",
};